
import { Routes, Route } from "react-router-dom";

import Main from "../pages/main";

/* landing page */
import LandingPage from "../pages/LandingPage";

/* menu itens */
import Howitworks from "../pages/Howitworks";
import Subscription from "../pages/Subscription";
import Whoweare from "../pages/Whoweare";

/* novo cliente */
import Register from "../pages/Register";

/* login */
import Login from "../pages/Login";
import Reset from "../pages/Login/reset";

/* termos de uso */
import Terms from "../pages/Terms";

/* páginas do Painel - Rotas Privadas */
import Panel from "../pages/Panel";
import Agent from "../pages/Agent";
import Account from "../pages/Account";
import Billing from "../pages/Billing";
import Performance from "../pages/Performance";
import Schedule from "../pages/Schedule";

/* agentes */
import Medical from "../pages/AgentsContent/Medical";
import Aesthetic from "../pages/AgentsContent/Aesthetic";

/* rotas privadas */
import Private from "./Private";

/* internas - adminnistrativas */
import Report from "../pages/Internal/report";
import Details from "../pages/Internal/operations";
import Operations from "../pages/Internal/operations";



function RoutesApp() {
    return(
        <Routes>
            
            <Route path="/" element={ <Main></Main> }></Route>

            <Route path="/lp" element={ <LandingPage></LandingPage> }></Route>

            <Route path="/howitworks" element={ <Howitworks></Howitworks> }></Route>
            <Route path="/subscription" element={ <Subscription></Subscription> }></Route>
            <Route path="/whoweare" element={ <Whoweare></Whoweare> }></Route>

            <Route path="/register" element={ <Register></Register> }></Route>

            <Route path="/login" element={ <Login></Login> }></Route>
            <Route path="/reset" element={ <Reset></Reset> }></Route>

            <Route path="/terms" element={ <Terms></Terms> }></Route>

            <Route path="/report" element={ <Report></Report> }></Route>
            <Route path="/operations" element={ <Operations></Operations> }></Route>

            {/* rotas privadas */}
            <Route path="/panel" element={ <Private><Panel></Panel></Private> }></Route>
            <Route path="/agent" element={ <Private><Agent></Agent></Private> }></Route>
            <Route path="/medical" element={ <Private><Medical></Medical></Private> }></Route>
            <Route path="/aesthetic" element={ <Private><Aesthetic></Aesthetic></Private> }></Route>
            <Route path="/account" element={ <Private><Account></Account></Private> }></Route>
            <Route path="/billing" element={ <Private><Billing></Billing></Private> }></Route>
            <Route path="/performance" element={ <Private><Performance></Performance></Private> }></Route>
            <Route path="/schedule" element={ <Private><Schedule></Schedule></Private> }></Route>
            
        </Routes>
    )
}

export default RoutesApp;